import React from "react";
import { Outlet } from "react-router-dom";
import { Shell } from "../../components/Shell";

const NAV = [
  { key: "dashboard", to: "/super", label: "Dashboard" },
  { key: "orgs", to: "/super/organizations", label: "Organizations" },
  { key: "admins", to: "/super/org-admins", label: "Org Admins" },
  { key: "branding", to: "/super/branding", label: "Branding" },
];

export default function SuperLayout() {
  return (
    <Shell nav={NAV}>
      <Outlet />
    </Shell>
  );
}
